<a
  *ngIf="currentProfile$ | async as currentProfile"
  [routerLink]="{ cxRoute: currentProfile.isLoggedIn ? 'myAccount' : 'login' } | cxUrl"
  [attr.data-analytics]="currentProfile.isLoggedIn ? null : 'btn_login'"
>
  <sd-tab-bar-item-legacy
    icon="PROFILE"
    [label]="currentProfile.user?.firstName"
    [isActive]="isActive$ | async"
  ></sd-tab-bar-item-legacy>
</a>
